/*
 * Define a form page asking the user if they have been relatiated against.
 */
import css from './pages.module.css'
import { yesNoPage } from './choicePage'

export const retaliatedAgainstPage = propOverrides => {
  const props = {
    pageId: 'retaliated_against_page',
    fieldName: 'retaliated_against',
    label: 'Have you been retaliated against?',
    className: css.choices,
    labelClassName: css.largeLabel,
    ...propOverrides
  }

  return yesNoPage({ ...props })
}
